import React from 'react'
import ExportMenuItemBase from './ExportMenuItemBase'
import {Area} from 'organization/Event/AreasProvider'
import {useEvent} from 'Event/EventProvider'
import {useOrganization} from 'organization/OrganizationProvider'
import {api} from 'lib/url'
import {useGet} from 'lib/requests'

export default function ExportRoomAssignmentsMenuItem(props: {
  area: Area
  setError: (error: string | null) => void
  setSuccess: (success: string | null) => void
}) {
  const {area, setError, setSuccess} = props

  const {
    exportRoomAssignments,
    processing,
    errorMessage,
    successMessage,
  } = useExportRoomAssignments(area)

  return (
    <ExportMenuItemBase
      ref={null}
      label="Export Room Assignments"
      ariaLabel="export room assignments"
      area={area}
      onExport={exportRoomAssignments}
      processing={processing}
      errorMessage={errorMessage}
      successMessage={successMessage}
      setError={setError}
      setSuccess={setSuccess}
    />
  )
}
function useExportRoomAssignments(area: Area) {
  const {event} = useEvent()
  const url = api(
    `/events/${event.id}/areas/${area.id}/room_assignments/export`,
  )
  const {client} = useOrganization()

  const {
    send: exportRoomAssignments,
    processing,
    errorMessage,
    successMessage,
  } = useGet(client, url)

  return {
    exportRoomAssignments,
    processing,
    errorMessage,
    successMessage,
  }
}
